import { COMMUNITY_URL } from '@/config/index.ts';
import { StyledFooter } from './Footer.styled.tsx';
import { useTranslation } from 'react-i18next';

import Logo from '/images/admitone.svg';

const Footer = () => {
    const { t } = useTranslation();
    return (
        <StyledFooter>
            <div className="fc_inner_container">
                <div className="fc_section">
                    <a className="fc_logo">
                        <img
                            src={Logo}
                            alt={t('footer.poweredBy', 'Powered by AdmitONE')}
                            style={{ width: '100%', maxWidth: '150px' }}
                        />
                    </a>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                    <ul className="fc_ul">
                        <li>
                            <a
                                className="fc_ul_link"
                                href={`${COMMUNITY_URL}privacy-policy`}
                                target="_blank"
                            >
                                {t('footer.privacyPolicy', 'Privacy Policy')}
                            </a>
                        </li>
                        <li>
                            <a
                                className="fc_ul_link"
                                href={`${COMMUNITY_URL}community/terms-of-service`}
                                target="_blank"
                            >
                                {t('footer.termsOfService', 'Terms of Services')}
                            </a>
                        </li>
                        <li>
                            <a
                                className="fc_ul_link"
                                href={`${COMMUNITY_URL}contact/community/customer-support`}
                                target="_blank"
                            >
                                {t('footer.contactUs', 'Contact us')}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </StyledFooter>
    );
};

export default Footer;
